import { render, staticRenderFns } from "./NewsAdvancedFilter.vue?vue&type=template&id=478810b2&"
import script from "./NewsAdvancedFilter.vue?vue&type=script&lang=js&"
export * from "./NewsAdvancedFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports